define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"csi",
	"csi/locale",
	"csi/store/Request",
	"csi/xml",
	"csi/xml/Search"
], function(array, declare, csi, locale, Request, xml, Search) {

	var loc = locale.getLocale();

	var _Store = declare(Request, {
		idProperty: "id",
		labelProperty: "name",

		_onResponse: function(/*Response*/res, /*Request*/req, /*Object*/options) {
			// summary: convert Locale nodes into name/value pairs
			var a = array.map(res.getNameAndUrls(), function(obj) {
				return {id: obj.Name, name: locale.resource(obj.Name)};
			});

			this._setData(csi.sort(a, "name"));
		}
	});

	var search = new Search({Operation: "NamesByXML"}).byType("Locale");
	search.getQuery().Attr("Active", xml.OP_EQUALS, true, "Child:SetupSettings");

	return new _Store({
		data: [{id: loc, name: locale.resource(loc)}],
		request: search.getRequest()
	});
});